import { wixP } from '../services/wix-params-utils';
// takes wix param or wix param path and state (determines is mobile from state) or boolean
export var getWixP = function (wixParam, isMobile) { return wixP(wixParam, isMobile); };
//# sourceMappingURL=wix-params-selectors.js.map